import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "@StarberryUtils";
import { LinkArrow } from "../Icons/Icons";
import { graphql, useStaticQuery } from "gatsby";
import { Helmet } from "react-helmet";

import "./CurrentVacancies.scss";

const CurrentVacancies = () => {
  const data = useStaticQuery(graphql`
    query GetCareers {
      glstrapi {
        careers {
          id
          JobTitle
          URL
          Location
          Department
          Salary
        }
      }
    }
  `);

  const careers = data.glstrapi.careers;

  return (
    <div className="current-vacancies-wrap sec-pdy-120">
      <Helmet> 
          <script src="https://scripts.teamtailor-cdn.com/widgets/eu-pink/jobs.js" async charset="utf-8"></script> 
      </Helmet>
      <Container>
        <Row>
          <Col>
            <h4>Current Vacancies</h4> 
            <div className="vacancy-details">
               <div class="teamtailor-jobs-widget" data-teamtailor-limit="20" data-teamtailor-api-key="g13ailUHAIAYWiRQ4wAJtB2QQKnNKf-aYDGY0WSk"></div> 
              {/* {careers.map((career) => (
                <div key={career.id} className="vacancy-items">
                  <div className="vacancy-title">
                   <Link to={`/about-dacha/careers/${career.URL}/`} className="text-sm">
                      <span className="d-flex d-lg-none text-md-bold"> {career.JobTitle.length > 16
                        ? `${career.JobTitle.slice(0, 16)}...`
                        : career.JobTitle}
                      </span>
                      <span className="d-none d-lg-flex text-md-bold">{career.JobTitle}</span>
                    </Link>
                    
                  </div>
                  <div className="vacancy-info d-none d-xl-flex">
                    <div className="vacancy-location vacancy-meta text-sm">
                      {career.Location}
                    </div>
                    <div className="vacancy-department vacancy-meta text-sm">
                      {career.Department}
                    </div>
                    <div className="vacancy-salary vacancy-meta text-sm">
                      {career.Salary}
                    </div>
                  </div>
                  <div className="vacancy-page-link">
                    <Link to={`/about-dacha/careers/${career.URL}/`} className="text-sm">
                      <span>View Details</span><span className="link-icon"><LinkArrow /></span>
                    </Link>
                  </div>
                </div>
              ))} */}


            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CurrentVacancies;